import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import {
  useGetStatisticsPensionContribution,
  useGetStatisticsPensionSubcontractors,
} from '@nxsys/hooks/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { useEffect, useMemo, useState } from 'react';
import PensionSubmissionErrorModal from './components/PensionSubmissionErrorModal';
import EnrollmentErrorModal from './components/EnrollmentErrorModal';
import AllPensionModal from './components/AllPensionModal';
import EmployeeModal, {
  EmployeeModalTypeEnum,
} from './components/EmployeeModal';

const PensionContribution = () => {
  const {
    value: dataPensionContributionValue,
    loading: loadingPensionContribution,
    run: runPensionContribution,
  } = useGetStatisticsPensionContribution();
  const dataPensionContribution = useMemo(
    () => dataPensionContributionValue?.data,
    [dataPensionContributionValue],
  );

  const {
    value: dataPensionSubcontractorsValue,
    loading: loadingPensionSubcontractors,
    run: runPensionSubcontractors,
  } = useGetStatisticsPensionSubcontractors();
  const dataPensionSubcontractors = useMemo(
    () => dataPensionSubcontractorsValue?.data,
    [dataPensionSubcontractorsValue],
  );
  const [isOpenSubmissionErrorModal, setIsOpenSubmissionErrorModal] =
    useState(false);

  const [isOpenEnrollmentErrorModal, setIsOpenEnrollmentErrorModal] =
    useState(false);

  const [isOpenAllPensionModal, setIsOpenAllPensionModal] = useState(false);

  const [isOpenPensionOptOutModal, setIsOpenPensionOptOutModal] =
    useState(false);

  useEffect(() => {
    runPensionContribution();
    runPensionSubcontractors();
  }, []);

  const cbAfterAction = () => {
    runPensionContribution();
    runPensionSubcontractors();
  };

  const items = [
    {
      title: dataPensionContribution?.totalErrorPension,
      description: 'Submission Errors',
      onClick: () => setIsOpenSubmissionErrorModal(true),
    },
    {
      title: dataPensionSubcontractors?.totalErrorSmartPensionEnrollments,
      description: 'Enrollment Errors',
      onClick: () => setIsOpenEnrollmentErrorModal(true),
    },
  ];

  return (
    <div className="OnHold h-full">
      <AppCard
        className="p-[24px] h-full"
        loading={loadingPensionContribution || loadingPensionSubcontractors}
      >
        <div className="flex justify-between items-center">
          <AppIconCard
            iconName="IconHandHoldingDollar"
            title="Pension Contribution"
          />
          <div className="flex gap-x-[4px]">
            <div className="flex items-center gap-x-[12px]">
              <div className="w-[38px] h-[38px] bg-[#FDF1F0] rounded-full flex justify-center items-center">
                <Icons.IconChairMoney />
              </div>
              <div className="text-[14px] font-[500]">
                <span className="text-gray-500">You have</span>{' '}
                <span
                  className="text-primary-600 cursor-pointer underline"
                  onClick={() => setIsOpenPensionOptOutModal(true)}
                >
                  {dataPensionContribution?.pensionOptOut ?? 0} Opt-Out in the
                  last 30 days.
                </span>
              </div>
            </div>
            <div
              className="flex items-center gap-x-[12px] cursor-pointer"
              onClick={() => setIsOpenAllPensionModal(true)}
            >
              <div className="text-[14px] font-[500] underline">
                See all pension
              </div>
              <Icons.IconArrowRight />
            </div>
          </div>
        </div>
        <div className="space-y-[16px] mt-[24px]">
          {items.map((item) => (
            <div
              key={item.title}
              className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px] flex items-center w-full gap-x-[12px]"
              onClick={item.onClick}
            >
              <div className="border-[3px] border-neutral-500 rounded-full w-[12px] h-[12px]"></div>
              <div className="flex gap-x-[8px] flex-1 items-center">
                <div className="text-[22px] font-bold">{item.title}</div>
                <div className="text-[14px] font-bold">{item.description}</div>
              </div>
              <Icons.IconArrowRight />
            </div>
          ))}
        </div>
      </AppCard>
      <PensionSubmissionErrorModal
        isOpen={isOpenSubmissionErrorModal}
        toggle={() => setIsOpenSubmissionErrorModal(false)}
        cbAfterAction={cbAfterAction}
      />
      <EnrollmentErrorModal
        isOpen={isOpenEnrollmentErrorModal}
        toggle={() => setIsOpenEnrollmentErrorModal(false)}
      />
      <AllPensionModal
        isOpen={isOpenAllPensionModal}
        toggle={() => setIsOpenAllPensionModal(false)}
      />
      <EmployeeModal
        isOpen={isOpenPensionOptOutModal}
        toggle={() => setIsOpenPensionOptOutModal(false)}
        type={EmployeeModalTypeEnum.PENSION_OPT_OUT}
      />
    </div>
  );
};

export default PensionContribution;
